import { variables } from "../../styles";

const { appToolbarMinHeight, drawerWidthClosed, drawerWidthOpen } = variables;

export default (theme) => ({
    appBarToolbarSpacer: {
        minHeight: appToolbarMinHeight
    },
    drawer: {
        flexShrink: 0,
        width: drawerWidthOpen,
        transition: theme.transitions.create(["width"])
    },
    drawerClosed: {
        width: `${drawerWidthClosed}px !important`,
        visibility: "visible"
    },
    drawerPaper: {
        width: drawerWidthOpen,
        overflowX: "hidden",
        overflowY: "auto",
        transition: theme.transitions.create(["width"])
    },
    listItem: {
        ...theme.mixins.toolbar,
        maxHeight: 64,
        paddingLeft: theme.spacing(2.5),
        "&:hover > * ": {
            color: theme.palette.primary.main
        }
    }
});
